import React, { useState, useEffect, useRef } from "react";
import styles from "./OperationSelectModal.module.scss";
import { getImageUrl } from "../../../../commons/assets_path";
import { useTranslation } from "react-i18next";

type Props = {
  code: string;
  image: string;
  name: string;
  isPlanLimited?: boolean;
  availablePlans?: string;
  isAppSelectView?: boolean;
  onClick?: () => void;
};

export const AppLabel = ({ code, image, name, isPlanLimited, availablePlans, isAppSelectView, onClick }: Props) => {
  const { t } = useTranslation();
  const TITLE_MAX_WIDTH = isAppSelectView ? 239 : 148;
  const [tooltipPosition, setTooltipPosition] = useState({ bottom: 0 });
  const [isTextWrapped, setIsTextWrapped] = useState(false);
  const operationDetailRef = useRef<HTMLDivElement | null>(null);
  const descriptionRef = useRef<HTMLDivElement | null>(null);

  const handleMouseEnter = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    const targetElement = e.currentTarget;

    if (targetElement) {
      const targetBounds = targetElement.getBoundingClientRect();

      // デフォルトは説明文を要素の下に表示
      let calculatedTooltipPosition = targetBounds.bottom + 5;

      // 説明文の高さを取得し、ウィンドウの高さをはみ出す場合の調整
      const tooltipHeight = descriptionRef.current?.clientHeight || 0;
      const tooltipHeightAdjustment = 3;
      const exceedsWindowBounds =
        calculatedTooltipPosition + tooltipHeight + tooltipHeightAdjustment >= window.innerHeight;

      if (exceedsWindowBounds) {
        // ウィンドウをはみ出す場合は説明文を要素の上に表示
        calculatedTooltipPosition = targetBounds.top - tooltipHeight - 5;
      }

      setTooltipPosition({ bottom: calculatedTooltipPosition });
    }
  };

  // NOTE: 文字が折り返されているかを判定
  useEffect(() => {
    if (operationDetailRef.current) {
      setIsTextWrapped(operationDetailRef.current.scrollWidth >= TITLE_MAX_WIDTH);
    }
  }, [name]);

  return (
    <div
      className={styles.operationCard}
      data-testid="AppLabel"
      onClick={onClick}
      onMouseEnter={(e) => handleMouseEnter(e)}
      style={{
        marginTop: isAppSelectView ? "0" : "12px",
        alignItems: isTextWrapped ? "flex-start" : "center",
      }}
    >
      <img
        src={code === "yoom" ? getImageUrl("images/icons/yoom_icon.png") : image}
        className={styles.operationImg}
        alt={name}
        width={32}
        height={32}
      />
      <div ref={operationDetailRef} className={styles.operationDetail}>
        <div className={styles.operationTitleArea}>
          <span className={styles.operationTitle}>{name}</span>
          {isPlanLimited && (
            <div className={styles.operationLimitedIcon}>
              <img
                src={getImageUrl("images/icons/operations/limited_icon_regular.svg")}
                alt="Limited"
                width="22"
                height="22"
              />
            </div>
          )}
        </div>
      </div>
      {isPlanLimited && availablePlans && (
        <div
          className={styles.appDescription}
          onClick={(e) => e.stopPropagation()}
          style={{ top: tooltipPosition.bottom }}
          ref={descriptionRef}
        >
          <span>{t("AppLabel.このアプリはプランで実行可能なアプリです。", { availablePlans: availablePlans })}</span>
        </div>
      )}
    </div>
  );
};
